<template>
    <div class="ladder-search-wrapper">
        <search-group title="设备查询" @search="find" @clear="clearValue" :span="14">
            <Row  class="mb16" :gutter="16">
                <Col span="6">
                    <Select v-model="params.projectFid" @on-change="changeProject" placeholder="项目名称">
                        <Option value="">请选择</Option>
                        <Option v-for="(item,index) in list.projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                    </Select>
                </Col>
                <Col span="6">
                    <Select v-model="params.buildingFid" placeholder="楼栋">
                        <Option value="">请选择</Option>
                        <Option v-for="item in list.buildList" :value="item.value" :key="item.value">{{item.text}}</Option>
                    </Select>
                </Col>
                <Col span="6">
                    <Select v-model="params.deviceType" placeholder="设备名称">
                        <Option value="">请选择</Option>
                        <Option value="0">门禁</Option>
                        <Option value="1">梯控</Option>
                    </Select>
                </Col>
                <Col span="6">
                    <Input v-model="params.deviceSn" placeholder="设备SN码"></Input>
                </Col>
            </Row>
        </search-group>
    </div>
</template>

<script type="text/ecmascript-6">
// import SearchGroup from 'components/SearchGroup/index';
import { getBuildInfo } from 'api/ladder.js';
export default {
    data () {
        return {
            params:{
                projectFid:'',  //项目fid
                buildingFid:'', // 楼栋fid
                deviceType:'',
                deviceSn:'',
                limit:10,
                page:1,
            },
            list:{
                projectList:[],
                buildList:[],
                deviceIdList:[]
            }
        }
    },
    created () {
        this.init()
    },
    components: {
        // SearchGroup
    },
    methods: {
        find() {
            this.$emit('find',this.params);
        },
        clearValue() {
            this.params.projectFid = '';
            this.params.buildingFid = '';
            this.params.deviceType = '';
            this.params.deviceSn = '';
        },
        init() {
            getBuildInfo().then(res => {
                this.list.projectList = res.data;
            })
        },
        changeProject(value) {
            this.params.buildingFid = '';
            if(value){
                let data = this.list.projectList.filter(item => item.value === value);
                this.list.buildList = data[0]['children'];
            }else{
                this.list.buildList = [];
            }
        }
    }
}
</script>
